import HeaderAdsApp from "./components/HeaderAdsApp.vue";
import { defineComponent, h } from "vue";
import { HeaderAdsSsrRequest } from "./types";

export default function createApp(data: HeaderAdsSsrRequest) {
	return defineComponent({
		setup() {
			return () => h(HeaderAdsApp, {
				props: {
					data,
				}
			});
		}
	});
}